export default "__VITE_ASSET__Cc2NX1B0__"